import { isFigmaEmbedContext } from '@/utils/auth.utils';
import { postReloadingToParent } from '@/utils/figma-embed-messages.utils';

export function reloadPageForWAF(): void {
  // Announce the reload first so the embed parent re-raises its loading overlay before the canvas
  // blanks (no banner flash over a black reload), matching the other embed reloads.
  if (isFigmaEmbedContext()) {
    postReloadingToParent();
  }
  window.location.reload();
}
